/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ContactsContent":"ContactsContent_NN8pz","scrollbarWrapper":"scrollbarWrapper_6hUn-","managerInfo":"managerInfo_Tin-M"};